var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "scrollContainer",
      staticClass: "messages flex-grow-1",
      class: _vm.classeSuperficie,
      staticStyle: { "overflow-y": "auto" }
    },
    [
      _c("transition", { attrs: { name: "iv2-carga-trilho", appear: "" } }, [
        _vm.mostraIndiceDeArtefatos
          ? _c(
              "div",
              { staticClass: "messages__indice-artefatos" },
              [
                _vm.painelProgressoContextoAtivo
                  ? _c("PainelFlutuante", {
                      staticClass: "messages__indice-artefatos-chip",
                      style: _vm.estiloDoPainelFlutuante,
                      attrs: {
                        "store-module": _vm.storeModule,
                        "largura-maxima": _vm.larguraMaximaDoIndiceDeArtefatos
                      },
                      on: {
                        abrir: _vm.abrirArtefatoDoIndice,
                        fechar: _vm.fecharArtefatoDoIndice
                      }
                    })
                  : _c("ChatIndiceArtefatos", {
                      staticClass: "messages__indice-artefatos-chip",
                      attrs: {
                        artefatos: _vm.artefatosDaConversa,
                        "store-module": _vm.storeModule,
                        "largura-maxima": _vm.larguraMaximaDoIndiceDeArtefatos
                      },
                      on: {
                        abrir: _vm.abrirArtefatoDoIndice,
                        fechar: _vm.fecharArtefatoDoIndice
                      }
                    })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm.mostraIndiceDeMensagens
        ? _c(
            "div",
            { staticClass: "messages__indice" },
            [
              _c("ChatIndiceMensagens", {
                staticClass: "messages__indice-coluna",
                attrs: {
                  mensagens: _vm.mensagensDoUsuario,
                  "id-ativa": _vm.idMensagemAtiva
                },
                on: { rolar: _vm.rolarAteMensagem }
              })
            ],
            1
          )
        : _vm._e(),
      _c("transition", { attrs: { name: "iv2-carga" } }, [
        _vm.carregandoMensagens
          ? _c(
              "div",
              { staticClass: "messages__carga" },
              [
                _c("v-progress-linear", {
                  attrs: {
                    indeterminate: "",
                    absolute: "",
                    top: "",
                    height: "4",
                    color: "primary"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "iv2-carga-trilho" } }, [
        _vm.mostraTrilho
          ? _c(
              "div",
              { ref: "trilho", class: _vm.classeTrilho },
              [
                _vm._t("antes-das-mensagens"),
                _vm._l(_vm.linhas, function(linha) {
                  return _c("ChatMessage", {
                    key: linha.msg.id || linha.indice,
                    attrs: {
                      "data-mensagem-id": linha.idDom,
                      "id-conversa": _vm.idConversa,
                      "store-module": _vm.storeModule,
                      atalhos: _vm.atalhos,
                      modulos: _vm.modulos,
                      message: linha.msg,
                      "painel-de-progresso-ativo":
                        _vm.painelProgressoContextoAtivo,
                      "is-streaming": false,
                      persona: _vm.persona,
                      "is-last": linha.isLast,
                      "ancora-de-artefatos": linha.ancoraDeArtefatos,
                      "respostas-do-formulario": linha.respostas,
                      "comando-do-turno": linha.comando,
                      "etapa-historica": _vm.ehEtapaHistorica(linha.msg),
                      "resposta-do-cartao": linha.respostaDoCartao,
                      "estado-do-run": _vm.estadoDoRunDaConversa,
                      "texto-revelado-inicial": _vm.textoReveladoDoTurno
                    },
                    on: {
                      feedback: _vm.onFeedback,
                      "open-service": _vm.onOpenService,
                      ask: _vm.onAsk,
                      respond: _vm.onRespond,
                      "responder-perguntas": _vm.onResponderPerguntas,
                      revelado: _vm.onRevelado,
                      "revelacao-concluida": _vm.onRevelacaoConcluida,
                      "avancou-apresentacao": _vm.onAvancouApresentacao
                    }
                  })
                }),
                _vm.showStreamingMessage
                  ? _c("ChatMessage", {
                      attrs: {
                        "id-conversa": _vm.idConversa,
                        "store-module": _vm.storeModule,
                        atalhos: _vm.atalhos,
                        modulos: _vm.modulos,
                        message: _vm.mensagemStreaming,
                        "is-streaming": true,
                        "active-tool-calls": _vm.toolCalls,
                        "streaming-plano": _vm.planoStreaming,
                        "painel-de-progresso-ativo":
                          _vm.painelProgressoContextoAtivo,
                        "streaming-busca": _vm.buscaStreaming,
                        "streaming-codigo": _vm.codigoStreaming,
                        "streaming-arquivo": _vm.arquivoStreaming,
                        "comando-do-turno": _vm.comandoDoTurnoAoVivo,
                        "aguardando-decisao": _vm.aguardandoDecisaoDoRun,
                        "estado-do-run": _vm.estadoDoRunDaConversa,
                        "streaming-tokens": _vm.responseTokens,
                        "streaming-thinking-steps": _vm.thinkingSteps,
                        persona: _vm.persona,
                        "streaming-servicos-citados":
                          _vm.servicosCitadosStreaming,
                        "streaming-perguntas-ao-gestor":
                          _vm.perguntasAoGestorStreaming,
                        "streaming-painel": _vm.painelStreaming
                      },
                      on: {
                        "open-service": _vm.onOpenService,
                        respond: _vm.onRespond,
                        revelado: _vm.onRevelado
                      }
                    })
                  : _vm._e()
              ],
              2
            )
          : _vm._e()
      ]),
      _vm.erroNoTrilho
        ? _c(
            "div",
            {
              class: _vm.classeTrilho,
              attrs: { "data-teste": "messages-erro-no-trilho" }
            },
            [
              _c(
                "div",
                { staticClass: "messages__erro az-card rounded-sm pa-6" },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex align-start" },
                    [
                      _c("icon-svg", {
                        staticClass: "mr-3 mt-1",
                        attrs: {
                          name: "warning-status",
                          size: 20,
                          color: "danger"
                        }
                      }),
                      _c("div", [
                        _c(
                          "p",
                          { staticClass: "ia-texto-trilho-erro-titulo mb-1" },
                          [_vm._v(_vm._s(_vm.TEXTO_ERRO.titulo))]
                        ),
                        _c(
                          "p",
                          { staticClass: "ia-texto-trilho-erro-corpo mb-0" },
                          [_vm._v(_vm._s(_vm.TEXTO_ERRO.corpo))]
                        )
                      ])
                    ],
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm.mostraVazio ? _vm._t("empty") : _vm._e(),
      _vm.painelProgressoContextoAtivo
        ? _c("MessagesEntregasAoVivo", {
            attrs: { "store-module": _vm.storeModule }
          })
        : _vm._e(),
      _c("div", { ref: "scrollSentinel", attrs: { "aria-hidden": "true" } }),
      _c("div", {
        ref: "espacoDoTurno",
        staticClass: "messages__bottom-spacer",
        style: { height: _vm.alturaDoEspacoDoTurno + "px" },
        attrs: { "aria-hidden": "true" }
      }),
      _c(
        "div",
        {
          staticClass: "messages__novas-linhas",
          attrs: { "aria-hidden": "false" }
        },
        [
          _c("transition", { attrs: { name: "iv2-carga" } }, [
            _vm.mostraNovasLinhas
              ? _c(
                  "button",
                  {
                    staticClass:
                      "messages__novas-linhas-pilula az-ds-selo d-inline-flex align-center",
                    attrs: {
                      type: "button",
                      "aria-label": _vm.textoNovasLinhas.aria,
                      "data-teste": "messages-novas-linhas"
                    },
                    on: { click: _vm.voltarAoFimDaResposta }
                  },
                  [
                    _c("icon-svg", {
                      staticClass: "mr-1",
                      attrs: {
                        name: "arrow-down-new-ux",
                        size: 12,
                        color: "currentColor"
                      }
                    }),
                    _vm._v(" " + _vm._s(_vm.textoNovasLinhas.rotulo) + " ")
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }